import { render, staticRenderFns } from "./CreatePurchaseRequest.vue?vue&type=template&id=7628ad3e&scoped=true&"
import script from "./CreatePurchaseRequest.vue?vue&type=script&lang=js&"
export * from "./CreatePurchaseRequest.vue?vue&type=script&lang=js&"
import style0 from "./CreatePurchaseRequest.vue?vue&type=style&index=0&id=7628ad3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7628ad3e",
  null
  
)

export default component.exports